const EMAIL_PATTERN = /^[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,64}$/

const isEmail = email => typeof email === 'string' && EMAIL_PATTERN.test(email)

export default isEmail
